import { PayloadAction } from "@reduxjs/toolkit";
import { LoanState } from "../loan.slice.ts";
import { SubmitIbanPayload } from "../../../actions/submit-iban.action.ts";

export function submitIbanReducer(
  state: LoanState,
  action: PayloadAction<SubmitIbanPayload>,
) {
  state.iban = {
    ibanCode: action.payload.iban!,
    ibanAttempts: state.iban.ibanAttempts + 1,
  };
}

export const errorSubmitIbanReducer = (state: LoanState) => {
  state.iban = {
    ...state.iban,
    ibanAttempts: state.iban.ibanAttempts + 1,
  };
};
